export interface ObjectUrlViewer {
  imageUrl?: string | null;
}

export interface ObjectUrlApi {
  createObjectURL(blob: Blob): string;
  revokeObjectURL(url: string): void;
}

export class OwnedObjectUrl {
  private url: string | null = null;

  constructor(private readonly urlApi: ObjectUrlApi = URL) {}

  assignToViewer(blob: Blob, viewer: ObjectUrlViewer): string {
    const previousUrl = this.url;
    if (previousUrl && previousUrl !== viewer?.imageUrl) {
      this.urlApi.revokeObjectURL(previousUrl);
    }

    const nextUrl = this.urlApi.createObjectURL(blob);
    viewer.imageUrl = nextUrl;
    this.url = nextUrl;

    if (previousUrl && previousUrl !== viewer.imageUrl) {
      this.urlApi.revokeObjectURL(previousUrl);
    }

    return nextUrl;
  }

  revokeIfUnused(viewer?: ObjectUrlViewer): void {
    if (!this.url) {
      return;
    }

    if (viewer?.imageUrl === this.url) {
      return;
    }

    this.urlApi.revokeObjectURL(this.url);
    this.url = null;
  }

  revokeFinal(): void {
    if (!this.url) {
      return;
    }

    this.urlApi.revokeObjectURL(this.url);
    this.url = null;
  }
}
